define('Components/RichTextWidget/js/models/RichTextWidgetInstanceModel',['jquery','WidgetInstanceModel','app','UrlFactory'],function($,WidgetInstanceModel,app,UrlFactory){
    return WidgetInstanceModel.extend({
        hasIcon: function(){
            var icon = this.getIcon();
            return icon && icon.length >0;
        },
        getIcon: function(suffix,format){
            return this.getParam('icon') || false;
        },
        getBgInlineStyle:function(){
            var id_picture = this.p('image');
            if(!!id_picture){
                console.log(id_picture);
                var url = UrlFactory.getUrlPicture(id_picture,'widget','noscale','widget','jpg');
                return 'style="background-image:url(\''+url+'\')"';
            }
            return '';
        }
    })
})
;
